import React from 'react';

const TAB_BASE = {
  padding: '0.5rem 0.5rem',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  fontSize: '0.9rem',
  marginBottom: '-2px',
  transition: 'all 0.2s',
  flex: '1 1 0',
  minWidth: '120px',
  maxWidth: '150px',
  textAlign: 'center',
  whiteSpace: 'normal',
  lineHeight: '1.3',
};

const tabStyle = (isActive) => ({
  ...TAB_BASE,
  fontWeight: isActive ? '600' : '400',
  color: isActive ? 'var(--text-color)' : 'var(--secondary-text-color)',
  borderBottom: isActive ? '3px solid var(--text-color)' : '3px solid transparent',
});

const TABS = [
  { id: 'api-keys', label: 'API Keys' },
  { id: 'connect', label: 'Connect' },
  { id: 'model-defaults', label: 'Model Defaults' },
  { id: 'personas', label: 'Personas' },
  { id: 'account', label: 'Security & Privacy' },
];

const TabNav = ({ activeTab, setActiveTab }) => (
  <div style={{
    display: 'flex',
    borderBottom: '2px solid var(--input-border)',
    marginBottom: '1.5rem',
    gap: '0.5rem',
    flexWrap: 'wrap',
  }}>
    {TABS.map(({ id, label }) => (
      <button key={id} onClick={() => setActiveTab(id)} style={tabStyle(activeTab === id)}>
        {label}
      </button>
    ))}
  </div>
);

export default TabNav;
